"use client";

import { ApolloForm } from "./ApolloForm";
import { CUSTOM_FORM_CONFIGS, type CustomFormId } from "./custom-form-config";

interface CustomFormProps {
	formId: CustomFormId;
	title?: string;
	description?: string;
	onSubmitSuccess?: () => void;
}

export function CustomForm({ formId, title, description, onSubmitSuccess }: CustomFormProps) {
	const config = CUSTOM_FORM_CONFIGS[formId];

	return (
		<ApolloForm
			app_id={config.app_id}
			title={title ?? config.title}
			description={description ?? config.description}
			fields={config.fields}
			required_fields={config.required_fields}
			field_labels={config.field_labels}
			scheduling_link={config.scheduling_link}
			form_id={config.form_id}
			hidden_form_id_value={config.form_id}
			success_message={config.success_message}
			on_submit_success={onSubmitSuccess}
		/>
	);
}

export type { CustomFormId };
